import { render, staticRenderFns } from "./CampaignEditor.vue?vue&type=template&id=cb9ec86a&"
import script from "./CampaignEditor.vue?vue&type=script&lang=ts&"
export * from "./CampaignEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports